import './App.css';
import Navbar from './components/navbar';
import Homepage from './components/home/homepage';
import NotFound from './components/404';
import { CreateLeague, ViewLeagueDetails } from './components/leagues/';
import AllTeams from './components/ipl/all-teams';
import SingleTeam from './components/ipl/single-team';
import Players from './components/ipl/players';
import Subs from './components/ipl/subs';
import Captains from './components/ipl/captains';
import AuctionSubs from './components/ipl/auction';
import { Switch, Route, withRouter } from "react-router-dom";
import Privacy from './components/privacy';
import TOS from './components/tos';
import Profile from './components/profile/profile';
import { ThemeProvider } from '@material-ui/core';
import { createTheme } from '@material-ui/core/styles';
import { ViewToken } from './components/view-token';
import SquadView from './components/ipl/squad-view';

function App() {
    const theme = createTheme();
    return (
        <ThemeProvider theme={theme}>
            <div className="App">
                <Navbar />
                <Switch>
                    <Route exact path="/" component={Homepage} />
                    <Route path="/leagues/create" component={CreateLeague} />
                    <Route path="/leagues/:leagueID/admin" render={(props) => <ViewLeagueDetails {...props} type="admin" />} />
                    <Route path="/leagues/:leagueID/settings" render={(props) => <ViewLeagueDetails {...props} type="settings" />} />
                    <Route path="/leagues/:leagueID/teams/:teamID/squad" component={SquadView} />
                    <Route path="/leagues/:leagueID/teams/:teamID/captains" component={withRouter(Captains)} />
                    <Route path="/leagues/:leagueID/teams/:teamID" component={SingleTeam} />
                    <Route path="/leagues/:leagueID" component={AllTeams} />
                    <Route path="/players/:tournament/:leagueID" component={Players} />
                    <Route path="/invite/:tokenCode" component={ViewToken} />
                    <Route path="/leagues/:leagueID/snakesubs" component={Subs} />
                    <Route path="/leagues/:leagueID/auctionsubs" component={AuctionSubs} />
                    <Route path="/profile" component={Profile} />
                    <Route path="/privacy" component={Privacy} />
                    <Route path="/tos" component={TOS} />
                    <Route path="*" component={NotFound} />
                </Switch>
            </div>
        </ThemeProvider>
    );
}

export default App;
